var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrendUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99847 12.1678C2.87177 12.1678 2.74507 12.1211 2.64504 12.0211C2.45165 11.8277 2.45165 11.5076 2.64504 11.3142L6.77897 7.1803C6.88567 7.0736 7.02571 7.02025 7.17908 7.03359C7.32579 7.04693 7.45916 7.12695 7.54585 7.25365L8.27272 8.34729L12.64 3.97996C12.8334 3.78657 13.1535 3.78657 13.3469 3.97996C13.5403 4.17335 13.5403 4.49344 13.3469 4.68682L8.54613 9.48761C8.43943 9.5943 8.29939 9.64765 8.14602 9.63431C7.99931 9.62098 7.86594 9.54096 7.77925 9.41425L7.05238 8.32061L3.3519 12.0211C3.25188 12.1211 3.12517 12.1678 2.99847 12.1678Z",
    fill: "#01C860"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9999 6.16724C12.7265 6.16724 12.4997 5.94051 12.4997 5.6671V4.83353H11.6662C11.3927 4.83353 11.166 4.6068 11.166 4.33339C11.166 4.05998 11.3927 3.83325 11.6662 3.83325H12.9999C13.2733 3.83325 13.5 4.05998 13.5 4.33339V5.6671C13.5 5.94051 13.2733 6.16724 12.9999 6.16724Z",
    fill: "#01C860"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendUp);
export default __webpack_public_path__ + "static/media/trend-up.ad75eb85d78a9ab9c4ded7c500b862bc.svg";
export { ForwardRef as ReactComponent };